import { Popconfirm, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button } from "@rumbledirect/ui";

export const dayLabels: Record<string, string> = {
  monday: "Maandag",
  tuesday: "Dinsdag",
  wednesday: "Woensdag",
  thursday: "Donderdag",
  friday: "Vrijdag",
  saturday: "Zaterdag",
  sunday: "Zondag",
};

interface ColumnOptions {
  showActions?: boolean;
  onEdit?: (item: any) => void;
  onDelete?: (item: any) => void;
}

export const appointmentTimeSlotPlanItemsColumns = ({
  showActions = true,
  onEdit,
  onDelete,
}: ColumnOptions) => {
  const columns: any[] = [
    {
      title: "Dag",
      dataIndex: "dayOfWeek",
      key: "dayOfWeek",
      render: (v: string, record: any) =>
        record.__group ? dayLabels[record.day] : (dayLabels[v] ?? v),
    },
    {
      title: "Start",
      dataIndex: "startTime",
      key: "startTime",
      render: (_: any, record: any) =>
        record.__group ? null : record.startTime,
    },
    {
      title: "Eind",
      dataIndex: "endTime",
      key: "endTime",
      render: (_: any, record: any) => (record.__group ? null : record.endTime),
    },
    {
      title: "Aantal",
      dataIndex: "amount",
      key: "amount",
      render: (_: any, record: any) => (record.__group ? null : record.amount),
    },
  ];

  if (showActions) {
    columns.push({
      title: "Acties",
      key: "actions",
      render: (_: any, record: any) =>
        record.__group ? null : (
          <Space>
            <Button icon={<EditOutlined />} onClick={() => onEdit?.(record)} />
            <Popconfirm
              title="Verwijder tijdslot?"
              onConfirm={() => onDelete?.(record)}
              okText="Ja"
              cancelText="Nee"
            >
              <Button danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </Space>
        ),
    });
  }

  return columns;
};
